import { render, staticRenderFns } from "./ticket-card-zkm.vue?vue&type=template&id=6550f3cb&scoped=true"
import script from "./ticket-card-zkm.vue?vue&type=script&lang=js"
export * from "./ticket-card-zkm.vue?vue&type=script&lang=js"
import style0 from "./ticket-card-zkm.vue?vue&type=style&index=0&id=6550f3cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6550f3cb",
  null
  
)

export default component.exports